import moment from "moment";

const getAge = (birthDate) => {
  var dateString = moment(`${birthDate}`).format("YYYYMMDD");
  return moment().diff(moment(dateString, "YYYYMMDD"), "years");
};

export default getAge;
